import { FC, useEffect } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { useGetProgressData } from 'hooks/useGetProgressData';
import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import Success from 'images/icon/success.svg';
import { useGetProgressQuery } from 'store/progress';

import styles from './CardSuccess.module.scss';

export const CardSuccess: FC = () => {
  const { refetch: refetchProgress } = useGetProgressQuery();
  const { data: progressData } = useGetProgressData();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // const [targetAreaStatus, setTargetAreaStatus] = useState<AreaStatus | null>(null);

  usePageTitle(`クリアカード`);

  // progressDataが変わったら、idが一致するAreaStatusを見つけてtargetAreaStatusにセット
  useEffect(() => {
    const fetchProgressAndSetTarget = async () => {
      await refetchProgress();
      if (progressData) {
        const target = progressData.areaStatusList.find(status => status.areaNo === Number(id));
        if (target) {
          await new Promise(resolve => setTimeout(resolve, 1000));
          // setTargetAreaStatus(target);
        }
      }
    };
    fetchProgressAndSetTarget();
  }, [progressData, id, refetchProgress]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <img src={Success} alt="" className={styles.Icon} />
          <p className={styles.message}>二次元コード読み取り成功！</p>
        </div>
        <div className={styles.foot}>
          <Button
            text="カードリストに戻る"
            styleType="secondary"
            handleClick={() => navigate('/card')}
          />
        </div>
      </div>
    </div>
  );
};
